import React from "react";
import { ChevronRight, ShieldCheck, Hammer, MapPin } from "lucide-react";

export default function Hero({ onQuoteClick }) {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-screen w-full overflow-hidden grain bg-[#0D0D0D]"
    >
      <img
        src="https://customer-assets.emergentagent.com/job_fencing-hub-2/artifacts/z0ubtl0s_IMG_20260511_222829.jpg"
        alt="Fresh timber paling fence by TradesmanDan"
        className="absolute inset-0 w-full h-full object-cover opacity-50"
      />
      <div className="absolute inset-0 bg-gradient-to-r from-[#0D0D0D] via-[#0D0D0D]/85 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-t from-[#0D0D0D] via-transparent to-transparent" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-10 pt-40 pb-24 grid lg:grid-cols-12 gap-10 items-end min-h-screen">
        <div className="lg:col-span-8 stamp-in">
          <div className="inline-flex items-center gap-3 border border-[#FF5A00] px-4 py-2 mb-8">
            <span className="w-2 h-2 bg-[#FF5A00]" />
            <span className="text-xs tracking-[0.3em] uppercase text-[#FF5A00] font-bold">
              Free Quotes · SE VIC + Gippsland
            </span>
          </div>

          <h1 className="font-heading uppercase text-white text-6xl sm:text-7xl lg:text-[8.5rem] leading-[0.85] tracking-tighter">
            Built To<br />
            <span className="text-[#FF5A00]">Last.</span> Built<br />
            For Locals.
          </h1>

          <p className="mt-10 text-lg lg:text-xl text-[#D4D4D4] max-w-xl leading-relaxed font-body">
            Residential, commercial &amp; ornamental fencing across South East
            Victoria &amp; Gippsland. No shortcuts, no surprises — just straight
            lines, square posts &amp; work that outlives the warranty.
          </p>

          <div className="mt-12 flex flex-col sm:flex-row gap-4">
            <button
              data-testid="hero-quote-btn"
              onClick={onQuoteClick}
              className="group bg-[#FF5A00] text-black font-heading tracking-[0.2em] uppercase px-8 py-5 hover:bg-[#E65100] transition-all flex items-center justify-center gap-3 text-base"
            >
              Get My Free Quote
              <ChevronRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
            </button>
            <a
              href="#gallery"
              data-testid="hero-view-work-btn"
              className="border-2 border-white/30 text-white font-heading tracking-[0.2em] uppercase px-8 py-5 hover:border-[#FF5A00] hover:text-[#FF5A00] transition-all flex items-center justify-center gap-3 text-base"
            >
              See Recent Work
            </a>
          </div>
        </div>

        <div className="lg:col-span-4 grid grid-cols-3 lg:grid-cols-1 gap-px bg-[#333]">
          {[
            { icon: ShieldCheck, label: "Fully Insured", sub: "$20M PL" },
            { icon: Hammer, label: "12+ Years", sub: "On The Tools" },
            { icon: MapPin, label: "Local Crew", sub: "SE Victoria" },
          ].map((stat, i) => (
            <div
              key={i}
              data-testid={`hero-stat-${i}`}
              className="bg-[#0D0D0D] p-6 lg:p-8 flex flex-col gap-2"
            >
              <stat.icon className="w-7 h-7 text-[#FF5A00]" strokeWidth={1.5} />
              <div className="font-heading text-white text-2xl lg:text-3xl uppercase tracking-tight mt-2">
                {stat.label}
              </div>
              <div className="text-xs tracking-[0.2em] uppercase text-[#A3A3A3]">
                {stat.sub}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Marquee */}
      <div className="absolute bottom-0 inset-x-0 z-10 border-t border-[#333] bg-[#0D0D0D] overflow-hidden">
        <div className="marquee flex whitespace-nowrap py-4 font-heading uppercase tracking-[0.3em] text-[#FF5A00]">
          {Array(2)
            .fill(0)
            .map((_, idx) => (
              <div key={idx} className="flex shrink-0">
                {[
                  "Timber Paling",
                  "Colorbond",
                  "Chain Link",
                  "Aluminium",
                  "Wrought Iron",
                  "Pool Fencing",
                  "Gates & Automation",
                  "Repairs",
                ].map((w) => (
                  <span key={w} className="px-8 text-sm">
                    ✦ {w}
                  </span>
                ))}
              </div>
            ))}
        </div>
      </div>
    </section>
  );
}
